import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\CheckupController::restore
* @see app/Http/Controllers/Admin/CheckupController.php:189
* @route '/dashboard/checkup/versions/{version}/restore'
*/
export const restore = (args: { version: string | number | { id: string | number } } | [version: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: restore.url(args, options),
    method: 'post',
})

restore.definition = {
    methods: ["post"],
    url: '/dashboard/checkup/versions/{version}/restore',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\CheckupController::restore
* @see app/Http/Controllers/Admin/CheckupController.php:189
* @route '/dashboard/checkup/versions/{version}/restore'
*/
restore.url = (args: { version: string | number | { id: string | number } } | [version: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { version: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { version: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            version: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        version: typeof args.version === 'object'
        ? args.version.id
        : args.version,
    }

    return restore.definition.url
            .replace('{version}', parsedArgs.version.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CheckupController::restore
* @see app/Http/Controllers/Admin/CheckupController.php:189
* @route '/dashboard/checkup/versions/{version}/restore'
*/
restore.post = (args: { version: string | number | { id: string | number } } | [version: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: restore.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::restore
* @see app/Http/Controllers/Admin/CheckupController.php:189
* @route '/dashboard/checkup/versions/{version}/restore'
*/
const restoreForm = (args: { version: string | number | { id: string | number } } | [version: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: restore.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CheckupController::restore
* @see app/Http/Controllers/Admin/CheckupController.php:189
* @route '/dashboard/checkup/versions/{version}/restore'
*/
restoreForm.post = (args: { version: string | number | { id: string | number } } | [version: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: restore.url(args, options),
    method: 'post',
})

restore.form = restoreForm

const versions = {
    restore: Object.assign(restore, restore),
}

export default versions